import { Component } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';

import { UserFormValidator } from '../../shared/user-validators';
import { GlowAuthService } from '../../services/glowadminservices/glowauth.service';

@Component({
    styleUrls: ['./reset-password.component.scss', '../public-components.scss'],
    templateUrl: './reset-password.component.html',
})

export class ResetPasswordComponent {
    public formInfo : FormGroup; 
    public errorString: string = "Password Reset Failure";
    public formError: boolean = false;
    public loading: boolean = false;
    public showInfoMessage: boolean = false;
  
    passwordType: string = 'password';
    passwordIcon: string = 'Show Password';

    constructor(
        private formBuilder: FormBuilder,
        private authService: GlowAuthService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
    
        this.formInfo = this.formBuilder.group({
            username: ['', Validators.required],
            token: ['', Validators.required],
            newPassword: ['', [Validators.required, UserFormValidator.isPasswordStrong]],
            confirmPassword: ['', [Validators.required, UserFormValidator.isNewPasswordSame]]
        });
        this.route.queryParams.subscribe(
            queryParams => {
              if (queryParams['showInfoMessage']) {
                this.showInfoMessage = true;
              }
            });
    }

    submitForm() {
        this.loading = true;
        this.formError = false;
        
        console.log("Password Reset attempt")

        var resetPasswordBody = {
            username : this.formInfo.value.username,
            token: this.formInfo.value.token,
            newPassword: this.formInfo.value.newPassword
        }
        this.authService.resetPassword(resetPasswordBody).subscribe((response) => {
            this.loading = false;

            if(response.valid===true){
                this.router.navigateByUrl('/login');
            }
            else{
                this.formError = true;
            }
        }, (err) => {
            this.loading = false;

            console.log("Error during login: ", err)
            this.formError = true;
        
        });
    }

    closeInfo() {
        this.showInfoMessage = false;
    }
    
    hideShowPassword() {
        this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
        this.passwordIcon = this.passwordIcon === 'Hide Password' ? 'Show Password' : 'Hide Password';
    }
}